import { MiniUsersResponseInterface } from "../users/users-response.interface";
import { AttachmentsResponseInterface } from "../attachments/attachments-response.interface";
import { Industry } from "../../utils/enums.utils";
import { VatType } from "../../utils/enums.utils";


export interface CompanyResponseInterface {
  id: string;
  company_name: string;
  industry: Industry;
  vat_type: VatType;
  product_service: string | null;
  payment_terms: string | null;
  status: CompanyStatus;
  address: string | null;
  tin_number: string | null;
  customer_code: string;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  attachment_company_logo: AttachmentsResponseInterface | null;
  attachment_org_chart: AttachmentsResponseInterface | null;
}

export enum CompanyStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
}